__turbopack_context__.v({
  "content": "FeedbackAnimation-module__i_hy2G__content",
  "contentWithFeedback": "FeedbackAnimation-module__i_hy2G__contentWithFeedback",
  "error-icon": "FeedbackAnimation-module__i_hy2G__error-icon",
  "errorIcon": "FeedbackAnimation-module__i_hy2G__errorIcon",
  "radial": "FeedbackAnimation-module__i_hy2G__radial",
  "radial-expand": "FeedbackAnimation-module__i_hy2G__radial-expand",
  "success-icon": "FeedbackAnimation-module__i_hy2G__success-icon",
  "successIcon": "FeedbackAnimation-module__i_hy2G__successIcon",
});
